import React, { useState } from "react"
import types from "prop-types"
import withReduxProvider from "shared/withReduxProvider"
import UserTabs from "./UserTabs"

const ShowUser = ({
  user: initialUser, accessOverviewDisplay, facilities, signInAudits, historicalAccessToolActions, userWorkflows,
}) => {
  const [user, setUser] = useState(initialUser)
  const updateRole = (role) => setUser({ ...user, role })
  const updateLocked = (locked) => setUser({ ...user, locked })
  const updateActiveAndRole = (active, role) => setUser({ ...user, role, active })
  const updateOTPConfirmed = (otpConfirmed) => setUser({ ...user, otpConfirmed })

  const removeGroupMembership = (id) => {
    const updatedGroupMemberships = user.groupMemberships.filter(
      (membership) => membership.id !== id,
    )

    setUser({
      ...user,
      groupMemberships: updatedGroupMemberships,
    })
  }

  const tabProps = {
    user,
    facilities,
    accessOverviewDisplay,
    setUser,
    removeGroupMembership,
    updateRole,
    updateLocked,
    updateActiveAndRole,
    updateOTPConfirmed,
    signInAudits,
    historicalAccessToolActions,
    userWorkflows,
  }

  return (
    <UserTabs tabProps={tabProps} />
  )
}

ShowUser.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: types.object.isRequired,
  accessOverviewDisplay: types.arrayOf(types.object).isRequired,
  signInAudits: types.arrayOf(types.object).isRequired,
  historicalAccessToolActions: types.arrayOf(types.object).isRequired,
  facilities: types.arrayOf(types.object).isRequired,
  userWorkflows: types.arrayOf(types.object).isRequired,
}

export default withReduxProvider(ShowUser)
